import { render, staticRenderFns } from "./grossing-touch-pending-view.vue?vue&type=template&id=76fe8cec&"
import script from "./grossing-touch-pending-view.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-pending-view.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports